// extracted by mini-css-extract-plugin
export default {"exceptionIcon":"ticket-status-label_exceptionIcon__cc3Ni"};